export enum FlowModes {
  CONNECT_ACCOUNT = 'connectAccount',
  LOGIN = 'login',
}

export type StripeOnboardingSearchParams = {
  mode: FlowModes;
  id: string;
};
